import React, { Component } from 'react';
import ReactHtmlParser from 'react-html-parser';
import './style.scss';
class Paragraph extends Component {
  constructor(){
    super()
    this.state = {}
  }

  render(){
    const { data } = this.props
    // console.log(`paragraph`, data)
    let classes = ['copy-body']
    classes = classes.join(' ')

    return(
      data && <div className={classes}>{ReactHtmlParser(data.lxl_paragraph)}</div>
    )
  }
}

export default Paragraph